module.exports = __webpack_public_path__ + "img/swiper4.b5274de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lifeHome/swiper4.png
// module id = 421
// module chunks = 0